/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drawer_Sort_NewestInputs */

const en_drawer_sort_newest = /** @type {(inputs: Drawer_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newest`)
};

const id_drawer_sort_newest = /** @type {(inputs: Drawer_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbaru`)
};

/**
* | output |
* | --- |
* | "Newest" |
*
* @param {Drawer_Sort_NewestInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const drawer_sort_newest = /** @type {((inputs?: Drawer_Sort_NewestInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drawer_Sort_NewestInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_drawer_sort_newest(inputs)
	return en_drawer_sort_newest(inputs)
});